import producer from 'immer';
import {
  SAVE_VIDEO_LINK,
  UPDATE_HAS_SNACK_BAR,
  UPLOAD_VIDEO_LINK,
  DELETE_VIDEO_LINK,
  FETCH_VIDEO_LINK,
} from './types';
import {
  handleSaveVideoLink,
  handleUpdateHasSnackbar,
  handleUploadVideo,
  handleDeleteVideoLink,
  handleFetchVideoLink,
} from './handlers';

export const initialState = {
  videoUrl: '',
  videoId: '',
  hasSnackbar: false,
  snackbarMessage: '',
  snackbarState: '',
};

export const videoReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case SAVE_VIDEO_LINK:
      return handleSaveVideoLink(state, action);
    case UPLOAD_VIDEO_LINK:
      return handleUploadVideo(state, action);
    case UPDATE_HAS_SNACK_BAR:
      return handleUpdateHasSnackbar(state, action);
    case DELETE_VIDEO_LINK:
      return handleDeleteVideoLink(state, action);
    case FETCH_VIDEO_LINK:
      return handleFetchVideoLink(state, action);
    default:
      return state;
  }
};

export default producer(videoReducer);
